import React from "react";
import CompanyContent from "../content/companyContent";
import Layout from "../layout/Layout";

const Company = () => {
  return (
    <Layout>
      <CompanyContent />
    </Layout>
  );
};

export default Company;
